import { openDB } from 'idb';

const DB_NAME = 'MyCarouselDB';
const STORE_NAME = 'carousels';

export const initDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' });
      }
    },
  });
};

export const saveImages = async (carousels) => {
    const db = await initDB();
    for (const item of carousels) {
        await db.put(STORE_NAME, item); // cada item debe tener un `id`
    }
};
export const updateImages = async (carousels) => {
  const db = await initDB();
  await db.delete(STORE_NAME);
  await db.put(STORE_NAME, carousels);
};

export const getImage = async (id) => {
  const db = await initDB();
  const entry = await db.get(STORE_NAME, id);
  return entry?.blob || null;
};

export const getAllImages = async () => {
  const db = await initDB();
  return await db.getAll(STORE_NAME);
};

export const clearCarouselStorage = async () => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    await tx.objectStore(STORE_NAME).clear();
    await tx.done

};